import React from "react";
import "./Description.scss";

const Description = () => {
  return (
    <section className="description">
      <div />
      <p>
        <div className="smallBottomRightborder" />
        <div className="smallTopLeftborder" />
        <div className="topRightDot" />
        <h3>About Me</h3>
        <span>
          Hi! My name is Dawid. I am frontend Developer that's currently looking
          for a job. Here's my portfolio so You can see all of my projects in
          one place. Enjoy!
        </span>
      </p>
    </section>
  );
};

export default Description;
